module.exports = __webpack_public_path__ + "img/img_06.6df40ac9.jpg";